import { TMainState } from './main.type'
import { TypeActions, Actions } from './main.actions'

export const reducer = (state: TMainState, { type, payload }: Actions) => {
  switch (type) {
    case TypeActions.SELECTED_IDS:
      return { ...state, selectedIds: payload }
    default:
      return state
  }
}
